"use client";

import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { cn } from "@/lib/utils";
import type { ActivityStatusKind } from "./derive-activity-presentation";

type ActivityProgressStatusProps = {
  label: string;
  className?: string;
};

/** LLM の処理が継続中であることを、視覚と支援技術の両方へ一貫して伝える。 */
export function ActivityProgressStatus({
  label,
  className,
}: ActivityProgressStatusProps) {
  return (
    <span
      aria-atomic="true"
      aria-live="polite"
      className={cn(
        "flex min-w-0 animate-pulse items-center text-muted-foreground text-[13px] motion-reduce:animate-none",
        className,
      )}
      data-activity-progress-status=""
      role="status"
    >
      <span className="min-w-0 truncate">{label}</span>
    </span>
  );
}

/** 待機表示とtool行の縦位置を同じチャット内リズムへ揃える。 */
export function ActivityProgressStatusRow({ label }: { label: string }) {
  return (
    <div
      className="flex h-10 w-fit max-w-full items-center"
      data-activity-progress-row=""
    >
      <ActivityProgressStatus label={label} />
    </div>
  );
}

/** 実行中 Activity の現在状態を短い一行で示す。 */
export function ActivityLiveStatus({ kind }: { kind: ActivityStatusKind }) {
  const { i18n } = useLingui();
  const label = {
    "preparing-response": i18n._(msg`Preparing a response...`),
    "preparing-next-step": i18n._(msg`Preparing the next step...`),
    "reviewing-tool-result": i18n._(msg`Reviewing the result...`),
  }[kind];
  return <ActivityProgressStatusRow label={label} />;
}
